/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
// Duplicate usage is ok here since it is used as a static value identifier

export enum CredibilityScore {
  TestPrediction = 0.4,
  ModelAnnotation = 0.5,
  ManualAnnotation = 0.6,
}

export enum CredibilityScoreThreshold {
  TestCenter = 0.4,
  DatasetCreation = 0.5,
  LabelCenter = 0.5
}
